export default __webpack_public_path__ + "static/media/img-proj-cmtransit.940ad286.png";